import React, { useEffect, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';

import api from '~/services/api';
import { t } from '~/helpers';
import { SimpleTable, Table } from '~/components';

import * as S from './styles';

export default function MyForm({ data }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const cells = useMemo(
    () => [
      {
        id: 'poco_codigo',
        label: 'Código',
      },
      {
        id: 'poco_desc_abrev',
        label: 'Nome',
      },
    ],
    []
  );

  const handleGetData = useCallback(async () => {
    try {
      setLoading(true);

      const response = await api.get('frentista/postos', {
        params: {
          wherefield: 'usua_login',
          valuewherefield: data.usua_login,
          typewherefield: 'EQUALS',
          pagesize: 99999,
        },
      });

      setItems(response.data.items);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    setItems([]);
    handleGetData();
  }, []);

  return (
    <div style={{ minWidth: '342px' }}>
      <Table
        cells={cells}
        data={items}
        loading={loading}
        size="small"
        title="Postos do Frentista"
        unique="poco_codigo"
      />
    </div>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
